// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1DKa7","rtl":"App_rtl__-XXu-","mainSection":"App_mainSection__3sctW","secondarySection":"App_secondarySection__3t6Rj","navBar":"App_navBar__1PShx"};